import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getPartnersPage = createAsyncThunk('partnersPage/getPartnersPage', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getPartnersPage();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
